module.exports = __webpack_public_path__ + "img/product_89.4be38ce.webp";